// // src/components/reports/CashCollectionReport.jsx
// // import React from 'react';
// // import PropTypes from 'prop-types';

// // const CashCollectionReport = ({
// //   cashData,
// //   totalWithoutWallet,
// //   taxAmount,
// //   dueAmount,
// //   advance,
// //   packagedata,
// //   memberdata,
// //   expenses
// // }) => {

// //   const nonWalletPayments = cashData?.filter(item => item.paymentType !== 'Wallet') || [];
// //   const walletPayments = cashData?.filter(item => item.paymentType === 'Wallet') || [];

// //   return (
// //     <div className="w-50" style={{ height: "50px" }}>
// //       <h6 style={{ fontWeight: 700, fontSize: '18px', textAlign: 'center' }}>
// //         Cash Collection Report
// //       </h6>
// //       <table style={{ width: "90%" }}>
// //         <thead className="table-thead">
// //           <tr>
// //             {['Payment Mode', 'Amount'].map((h, index) => {
// //               return (
// //                 <th key={index} style={{ width: '100%' }}>
// //                   {h}
// //                 </th>
// //               );
// //             })}
// //           </tr>
// //         </thead>
// //         <tbody className="table-tbody">
// //           {/* Cash Payments (non-wallet) */}
// //           {/* <tr style={{ background: '#ebebe0' }}>
// //             <td style={{ width: '100%', fontWeight: 'bold' }}>Cash</td>
// //             <td style={{ width: '100%', fontWeight: 'bold' }}>
// //               {nonWalletPayments.reduce((sum, item) => sum + (item.totalAmounts || 0), 0)}
// //             </td>
// //           </tr> */}

// //           {/* Other Payment Modes (non-wallet) */}
// //           {nonWalletPayments.map((item, key) => (
// //             <tr key={key}>
// //               <td style={{ width: '100%' }}>{item.paymentType}</td>
// //               <td style={{ width: '100%' }}>{item.totalAmounts}</td>
// //             </tr>
// //           ))}

// //           {/* Expenses */}
// //           <tr style={{ background: '#ebebe0' }}>
// //             <td style={{ width: '100%', fontWeight: 'bold' }}>Expenses</td>
// //             <td style={{ width: '100%', fontWeight: 'bold' }}>
// //               {Math.round(expenses) || 0}
// //             </td>
// //           </tr>

// //           {/* Net Amount (Total - Expenses) */}
// //           <tr style={{ background: 'lightgreen' }}>
// //             <td style={{ width: '100%', fontWeight: 'bold' }}>Total</td>
// //             <td style={{ width: '100%', fontWeight: 'bold' }}>
// //               {Math.round(totalWithoutWallet - (expenses || 0))}
// //             </td>
// //           </tr>

// //           {/* Advance */}
// //           <tr style={{ background: 'lightgreen' }}>
// //             <td style={{ width: '100%', fontWeight: 'bold' }}>Advance</td>
// //             <td style={{ width: '100%', fontWeight: 'bold' }}>
// //               {Math.round(advance)}
// //             </td>
// //           </tr>

// //           {/* Dues */}
// //           <tr style={{ background: 'pink' }}>
// //             <td style={{ width: '100%', fontWeight: 'bold' }}>Dues</td>
// //             <td style={{ width: '100%', fontWeight: 'bold' }}>
// //               {Math.round(dueAmount)}
// //             </td>
// //           </tr>

// //           {/* GST Collected */}
// //           <tr style={{ background: '#ebebe0' }}>
// //             <td style={{ width: '100%', fontWeight: 'bold' }}>GST Collected</td>
// //             <td style={{ width: '100%', fontWeight: 'bold' }}>
// //               {Math.round(taxAmount)}
// //             </td>
// //           </tr>

// //           {/* Membership Sales */}
// //           <tr style={{ background: '#ebebe0' }}>
// //             <td style={{ width: '100%', fontWeight: 'bold' }}>Membership</td>
// //             <td style={{ width: '100%', fontWeight: 'bold' }}>
// //               {Math.round(memberdata?.totalAmount) || 0}
// //             </td>
// //           </tr>

// //           {/* Package Sales */}
// //           <tr style={{ background: '#ebebe0' }}>
// //             <td style={{ width: '100%', fontWeight: 'bold' }}>Package</td>
// //             <td style={{ width: '100%', fontWeight: 'bold' }}>
// //               {Math.round(packagedata?.totalAmount) || 0}
// //             </td>
// //           </tr>

// //           {/* Wallet Payments */}
// //           {walletPayments.map((item, key) => (
// //             <tr key={`wallet-${key}`} style={{ background: '#ebebe0' }}>
// //               <td style={{ width: '100%', fontWeight: 'bold' }}>Wallet Payment</td>
// //               <td style={{ width: '100%', fontWeight: 'bold' }}>
// //                 {item.totalAmounts}
// //               </td>
// //             </tr>
// //           ))}


// //         </tbody>
// //       </table>
// //     </div>
// //   );
// // };

// // CashCollectionReport.propTypes = {
// //   cashData: PropTypes.arrayOf(
// //     PropTypes.shape({
// //       paymentType: PropTypes.string.isRequired,
// //       totalAmounts: PropTypes.number.isRequired
// //     })
// //   ),
// //   totalWithoutWallet: PropTypes.number.isRequired,
// //   taxAmount: PropTypes.number.isRequired,
// //   dueAmount: PropTypes.number.isRequired,
// //   advance: PropTypes.number.isRequired,
// //   packagedata: PropTypes.shape({
// //     totalAmount: PropTypes.number
// //   }),
// //   memberdata: PropTypes.shape({
// //     totalAmount: PropTypes.number
// //   })
// // };

// // CashCollectionReport.defaultProps = {
// //   cashData: [],
// //   packagedata: { totalAmount: 0 },
// //   memberdata: { totalAmount: 0 }
// // };

// // export default CashCollectionReport;


// // cash collection without minusing expense
// import React from 'react';
// import PropTypes from 'prop-types';

// const CashCollectionReport = ({
//   cashData,
//   totalWithoutWallet,
//   taxAmount,
//   dueAmount,
//   advance,
//   packagedata,
//   memberdata,
//   expenses,
// }) => {
//   const nonWalletPayments = cashData?.filter((item) => item.paymentType !== 'Wallet') || [];
//   const walletPayments = cashData?.filter((item) => item.paymentType === 'Wallet') || [];

//   return (
//     <div className="w-50" style={{ height: '50px' }}>
//       <h6 style={{ fontWeight: 700, fontSize: '18px', textAlign: 'center' }}>
//         Cash Collection Report
//       </h6>
//       <table style={{ width: '90%' }}>
//         <thead className="table-thead">
//           <tr>
//             {['Payment Mode', 'Amount'].map((h, index) => {
//               return (
//                 <th key={index} style={{ width: '100%' }}>
//                   {h}
//                 </th>
//               );
//             })}
//           </tr>
//         </thead>
//         <tbody className="table-tbody">
//           {/* Cash Payments (non-wallet) */}
//           {/* <tr style={{ background: '#ebebe0' }}>
//             <td style={{ width: '100%', fontWeight: 'bold' }}>Cash</td>
//             <td style={{ width: '100%', fontWeight: 'bold' }}>
//               {nonWalletPayments.reduce((sum, item) => sum + (item.totalAmounts || 0), 0)}
//             </td>
//           </tr> */}

//           {/* Other Payment Modes (non-wallet) */}
//           {nonWalletPayments.map((item, key) => (
//             <tr key={key}>
//               <td style={{ width: '100%' }}>{item.paymentType}</td>
//               <td style={{ width: '100%' }}>{item.totalAmounts}</td>
//             </tr>
//           ))}

//           {/* Expenses */}
//           {/* <tr style={{ background: '#ebebe0' }}>
//             <td style={{ width: '100%', fontWeight: 'bold' }}>Expenses</td>
//             <td style={{ width: '100%', fontWeight: 'bold' }}>{Math.round(expenses) || 0}</td>
//           </tr> */}

//           {/* Net Amount (Total - Expenses) */}
//           <tr style={{ background: 'lightgreen' }}>
//             <td style={{ width: '100%', fontWeight: 'bold' }}>Total</td>
//             <td style={{ width: '100%', fontWeight: 'bold' }}>
//               {Math.round(totalWithoutWallet ||0)}
//             </td>
//           </tr>

//           {/* Advance */}
//           <tr style={{ background: 'lightgreen' }}>
//             <td style={{ width: '100%', fontWeight: 'bold' }}>Advance</td>
//             <td style={{ width: '100%', fontWeight: 'bold' }}>{Math.round(advance)}</td>
//           </tr>

//           {/* Dues */}
//           <tr style={{ background: 'pink' }}>
//             <td style={{ width: '100%', fontWeight: 'bold' }}>Dues</td>
//             <td style={{ width: '100%', fontWeight: 'bold' }}>{Math.round(dueAmount)}</td>
//           </tr>

//           {/* GST Collected */}
//           <tr style={{ background: '#ebebe0' }}>
//             <td style={{ width: '100%', fontWeight: 'bold' }}>GST Collected</td>
//             <td style={{ width: '100%', fontWeight: 'bold' }}>{Math.round(taxAmount)}</td>
//           </tr>

//           {/* Membership Sales */}
//           <tr style={{ background: '#ebebe0' }}>
//             <td style={{ width: '100%', fontWeight: 'bold' }}>Membership</td>
//             <td style={{ width: '100%', fontWeight: 'bold' }}>
//               {Math.round(memberdata?.totalAmount) || 0}
//             </td>
//           </tr>

//           {/* Package Sales */}
//           <tr style={{ background: '#ebebe0' }}>
//             <td style={{ width: '100%', fontWeight: 'bold' }}>Package</td>
//             <td style={{ width: '100%', fontWeight: 'bold' }}>
//               {Math.round(packagedata?.totalAmount) || 0}
//             </td>
//           </tr>

//           {/* Wallet Payments */}
//           {walletPayments.map((item, key) => (
//             <tr key={`wallet-${key}`} style={{ background: '#ebebe0' }}>
//               <td style={{ width: '100%', fontWeight: 'bold' }}>Wallet Payment</td>
//               <td style={{ width: '100%', fontWeight: 'bold' }}>{item.totalAmounts}</td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// CashCollectionReport.propTypes = {
//   cashData: PropTypes.arrayOf(
//     PropTypes.shape({
//       paymentType: PropTypes.string.isRequired,
//       totalAmounts: PropTypes.number.isRequired,
//     }),
//   ),
//   totalWithoutWallet: PropTypes.number.isRequired,
//   taxAmount: PropTypes.number.isRequired,
//   dueAmount: PropTypes.number.isRequired,
//   advance: PropTypes.number.isRequired,
//   packagedata: PropTypes.shape({
//     totalAmount: PropTypes.number,
//   }),
//   memberdata: PropTypes.shape({
//     totalAmount: PropTypes.number,
//   }),
// };

// CashCollectionReport.defaultProps = {
//   cashData: [],
//   packagedata: { totalAmount: 0 },
//   memberdata: { totalAmount: 0 },
// };

// export default CashCollectionReport;

// // src/components/reports/CashCollectionReport.jsx
// import React from 'react';
// import PropTypes from 'prop-types';

// const CashCollectionReport = ({
//   cashData,
//   totalWithoutWallet,
//   taxAmount,
//   dueAmount,
//   advance,
//   packagedata,
//   memberdata,
//   expenses
// }) => {
//   return (
//     <div className="w-50" style={{ height: "50px" }}>
//       <h6 style={{ fontWeight: 700, fontSize: '18px', textAlign: 'center' }}>
//         Cash Collection Report
//       </h6>
//       <table style={{ width: "90%" }}>
//         <thead className="table-thead">
//           <tr>
//             {['Payment Mode', 'Amount'].map((h, index) => {
//               return (
//                 <th key={index} style={{ width: '100%' }}>
//                   {h}
//                 </th>
//               );
//             })}
//           </tr>
//         </thead>
//         <tbody className="table-tbody">
//           {cashData?.map((item, key) => (
//             <tr key={key}>
//               <td style={{ width: '100%' }}>{item.paymentType}</td>
//               <td style={{ width: '100%' }}>{item.totalAmounts}</td>
//             </tr>
//           ))}
//           <tr style={{ background: '#ebebe0' }}>
//             <td style={{ width: '100%', fontWeight: 'bold' }}>Package</td>
//             <td style={{ width: '100%', fontWeight: 'bold' }}>
//               {Math.round(packagedata?.totalAmount) || 0}
//             </td>
//           </tr>
//           <tr style={{ background: '#ebebe0' }}>
//             <td style={{ width: '100%', fontWeight: 'bold' }}>Membership</td>
//             <td style={{ width: '100%', fontWeight: 'bold' }}>
//               {Math.round(memberdata?.totalAmount) || 0}
//             </td>
//           </tr>
//           <tr style={{ background: 'lightgreen' }}>
//             <td style={{ width: '100%', fontWeight: 'bold' }}>Advance</td>
//             <td style={{ width: '100%', fontWeight: 'bold' }}>
//               {Math.round(advance)}
//             </td>
//           </tr>
//             <tr style={{ background: '#ebebe0' }}>
//             <td style={{ width: '100%', fontWeight: 'bold' }}>GST Collected</td>
//             <td style={{ width: '100%', fontWeight: 'bold' }}>
//               {Math.round(taxAmount)}
//             </td>
//           </tr>
//           <tr style={{ background: '#ebebe0' }}>
//             <td style={{ width: '100%', fontWeight: 'bold' }}>Total</td>
//             <td style={{ width: '100%', fontWeight: 'bold' }}>
//               {Math.round(totalWithoutWallet)}
//             </td>
//           </tr>
//           <tr style={{ background: '#ebebe0' }}>
//             <td style={{ width: '100%', fontWeight: 'bold' }}>Expenses</td>
//             <td style={{ width: '100%', fontWeight: 'bold' }}>
//               {Math.round(expenses) || 0}
//             </td>
//           </tr>
//               <tr style={{ background: 'pink' }}>
//             <td style={{ width: '100%', fontWeight: 'bold' }}>Dues</td>
//             <td style={{ width: '100%', fontWeight: 'bold' }}>
//               {Math.round(dueAmount)}
//             </td>
//           </tr>
//         </tbody>
//       </table>
//     </div>
//   );
// };

// CashCollectionReport.propTypes = {
//   cashData: PropTypes.arrayOf(
//     PropTypes.shape({
//       paymentType: PropTypes.string.isRequired,
//       totalAmounts: PropTypes.number.isRequired
//     })
//   ),
//   totalWithoutWallet: PropTypes.number.isRequired,
//   taxAmount: PropTypes.number.isRequired,
//   dueAmount: PropTypes.number.isRequired,
//   advance: PropTypes.number.isRequired,
//   packagedata: PropTypes.shape({
//     totalAmount: PropTypes.number
//   }),
//   memberdata: PropTypes.shape({
//     totalAmount: PropTypes.number
//   })
// };

// CashCollectionReport.defaultProps = {
//   cashData: [],
//   packagedata: { totalAmount: 0 },
//   memberdata: { totalAmount: 0 }
// };

// export default CashCollectionReport;



// Code with expense minused
// src/components/reports/CashCollectionReport.jsx
// import React from 'react';
// import PropTypes from 'prop-types';

// const CashCollectionReport = ({
//   cashData,
//   totalWithoutWallet,
//   taxAmount,
//   dueAmount,
//   advance,
//   packagedata,
//   memberdata,
//   expenses
// }) => {
//   // Filter out wallet payments from cashData
//   const nonWalletPayments = cashData?.filter(item => item.paymentType !== 'Wallet') || [];
//   const walletPayments = cashData?.filter(item => item.paymentType === 'Wallet') || [];

//   return (
//     <div className="w-50" style={{ height: "50px" }}>
//       <h6 style={{ fontWeight: 700, fontSize: '18px', textAlign: 'center' }}>
//         Cash Collection Report
//       </h6>
//       <table style={{ width: "90%" }}>
//         <thead className="table-thead">
//           <tr>
//             {['Payment Mode', 'Amount'].map((h, index) => {
//               return (
//                 <th key={index} style={{ width: '100%' }}>
//                   {h}
//                 </th>
//               );
//             })}
//           </tr>
//         </thead>
//         <tbody className="table-tbody">
//           {/* Cash Payments (non-wallet) */}
//           {/* <tr style={{ background: '#ebebe0' }}>
//             <td style={{ width: '100%', fontWeight: 'bold' }}>Cash</td>
//             <td style={{ width: '100%', fontWeight: 'bold' }}>
//               {nonWalletPayments.reduce((sum, item) => sum + (item.totalAmounts || 0), 0)}
//             </td>
//           </tr> */}

//           {/* Other Payment Modes (non-wallet) */}
//           {nonWalletPayments.map((item, key) => (
//             <tr key={key}>
//               <td style={{ width: '100%' }}>{item.paymentType}</td>
//               <td style={{ width: '100%' }}>{item.totalAmounts}</td>
//             </tr>
//           ))}

//           {/* Expenses */}
//           <tr style={{ background: '#ebebe0' }}>
//             <td style={{ width: '100%', fontWeight: 'bold' }}>Expenses</td>
//             <td style={{ width: '100%', fontWeight: 'bold' }}>
//               {Math.round(expenses) || 0}
//             </td>
//           </tr>

//           {/* Net Amount (Total - Expenses) */}
//           <tr style={{ background: 'lightgreen' }}>
//             <td style={{ width: '100%', fontWeight: 'bold' }}>Total</td>
//             <td style={{ width: '100%', fontWeight: 'bold' }}>
//               {Math.round(totalWithoutWallet - (expenses || 0))}
//             </td>
//           </tr>

//           {/* Advance */}
//           <tr style={{ background: 'lightgreen' }}>
//             <td style={{ width: '100%', fontWeight: 'bold' }}>Advance</td>
//             <td style={{ width: '100%', fontWeight: 'bold' }}>
//               {Math.round(advance)}
//             </td>
//           </tr>

//           {/* Dues */}
//           <tr style={{ background: 'pink' }}>
//             <td style={{ width: '100%', fontWeight: 'bold' }}>Dues</td>
//             <td style={{ width: '100%', fontWeight: 'bold' }}>
//               {Math.round(dueAmount)}
//             </td>
//           </tr>

//           {/* GST Collected */}
//           <tr style={{ background: '#ebebe0' }}>
//             <td style={{ width: '100%', fontWeight: 'bold' }}>GST Collected</td>
//             <td style={{ width: '100%', fontWeight: 'bold' }}>
//               {Math.round(taxAmount)}
//             </td>
//           </tr>

//           {/* Membership Sales */}
//           <tr style={{ background: '#ebebe0' }}>
//             <td style={{ width: '100%', fontWeight: 'bold' }}>Membership</td>
//             <td style={{ width: '100%', fontWeight: 'bold' }}>
//               {Math.round(memberdata?.totalAmount) || 0}
//             </td>
//           </tr>

//           {/* Package Sales */}
//           <tr style={{ background: '#ebebe0' }}>
//             <td style={{ width: '100%', fontWeight: 'bold' }}>Package</td>
//             <td style={{ width: '100%', fontWeight: 'bold' }}>
//               {Math.round(packagedata?.totalAmount) || 0}
//             </td>
//           </tr>

//           {/* Wallet Payments */}
//           {walletPayments.map((item, key) => (
//             <tr key={`wallet-${key}`} style={{ background: '#ebebe0' }}>
//               <td style={{ width: '100%', fontWeight: 'bold' }}>Wallet Payment</td>
//               <td style={{ width: '100%', fontWeight: 'bold' }}>
//                 {item.totalAmounts}
//               </td>
//             </tr>
//           ))}


//         </tbody>
//       </table>
//     </div>
//   );
// };

// CashCollectionReport.propTypes = {
//   cashData: PropTypes.arrayOf(
//     PropTypes.shape({
//       paymentType: PropTypes.string.isRequired,
//       totalAmounts: PropTypes.number.isRequired
//     })
//   ),
//   totalWithoutWallet: PropTypes.number.isRequired,
//   taxAmount: PropTypes.number.isRequired,
//   dueAmount: PropTypes.number.isRequired,
//   advance: PropTypes.number.isRequired,
//   packagedata: PropTypes.shape({
//     totalAmount: PropTypes.number
//   }),
//   memberdata: PropTypes.shape({
//     totalAmount: PropTypes.number
//   }),
//   expenses: PropTypes.number
// };

// CashCollectionReport.defaultProps = {
//   cashData: [],
//   packagedata: { totalAmount: 0 },
//   memberdata: { totalAmount: 0 },
//   expenses: 0
// };

// export default CashCollectionReport;












import React from "react";
import { Box } from "@mui/material";
import {
  FaMoneyBillWave,
  FaChartLine,
  FaExclamationCircle,
} from "react-icons/fa";
const calculateActualDue = (billDetails = []) => {
  return billDetails.reduce((total, bill) => {
    // Skip the "due payment" records (they are not real bills)
    if (bill.createdBillFor === "Due") return total;

    const originalDue = Number(bill.paidDues || 0);
    if (originalDue <= 0) return total;

    const alreadyPaid = (bill.dueBillHistory || []).reduce(
      (sum, h) => sum + Number(h.paidAmount || 0),
      0
    );

    // Never go below 0
    return total + Math.max(originalDue - alreadyPaid, 0);
  }, 0);
};

const formatAmount = (value = 0) =>
  `₹ ${Number(value).toLocaleString("en-IN")}`;

const SummaryCard = ({ title, value, gradient, icon: Icon }) => (
  <div
    style={{
      flex: 1,
      padding: "15px",
      borderRadius: "16px",
      background: gradient,
      color: "#fff",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      minWidth: "120px",
      position: "relative",
      overflow: "hidden",
      boxShadow:
        "0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -2px rgba(0,0,0,0.05)",
      height: "110px",
    }}
  >
    <div style={{ position: "relative", zIndex: 2 }}>
      <div
        style={{
          fontSize: "12px",
          fontWeight: "600",
          textTransform: "uppercase",
          letterSpacing: "0.5px",
          opacity: 0.9,
          marginBottom: "4px",
        }}
      >
        {title}
      </div>
      <div
        style={{
          fontSize: "22px",
          fontWeight: "800",
          letterSpacing: "-0.5px",
        }}
      >
        {formatAmount(value)}
      </div>
    </div>

    {Icon && (
      <Icon
        style={{
          position: "absolute",
          right: "10px",
          bottom: "10px",
          fontSize: "50px",
          opacity: 0.5,
          zIndex: 1,
        }}
      />
    )}
  </div>
);

const Row = ({ label, value, bold = false, highlight = false }) => (
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "6px",
      marginBottom: "6px",
      borderRadius: "8px",
      backgroundColor: highlight
        ? "rgba(97,116,221,0.08)"
        : "#f8f9fa",
      border: highlight
        ? "1px solid rgba(97,116,221,0.2)"
        : "1px solid transparent",
    }}
  >
    <span
      style={{
        fontWeight: bold ? "700" : "500",
        color: bold ? "#333" : "#555",
        fontSize: "14px",
        display: "flex",
        alignItems: "center",
        gap: "10px",
      }}
    >
      {!bold && (
        <div
          style={{
            width: "5px",
            height: "5px",
            borderRadius: "50%",
            backgroundColor: "#cbd5e0",
          }}
        />
      )}
      {label}
    </span>

    <span
      style={{
        fontWeight: bold ? "800" : "600",
        color: bold ? "#6174DD" : "#333",
        fontSize: bold ? "15px" : "14px",
      }}
    >
      {formatAmount(value)}
    </span>
  </div>
);

const SectionHeader = ({ title }) => (
  <div style={{ display: "flex", alignItems: "center", margin: "12px 0 6px" }}>
    <h4
      style={{
        fontSize: "15px",
        fontWeight: "700",
        color: "#a0aec0",
        textTransform: "uppercase",
        letterSpacing: "1px",
        marginRight: "12px",
        whiteSpace: "nowrap",
      }}
    >
      {title}
    </h4>
    <div style={{ height: "1px", width: "100%", backgroundColor: "#e2e8f0" }} />
  </div>
);

const CashCollectionReport = ({
  cashData = [],
  totalWithoutWallet = 0,
  taxAmount = 0,
  dueAmount = 0,
  advance = 0,
  packagedata = {},
  memberdata = {},
    totalAmountPaid = 0,
  billDetails = [],
}) => {
   const actualDue = billDetails.length
    ? calculateActualDue(billDetails)
    : dueAmount;
  const walletAmount =
    cashData.find((p) => p.paymentType === "Wallet")?.totalAmounts || 0;

  const nonWalletPayments = cashData.filter(
    (p) => p.paymentType !== "Wallet"
  );

  return (
    <div
      style={{
        width: "100%",
        maxWidth: "900px",
        margin: "0 auto",
        padding: "15px",
        borderRadius: "20px",
        background: "#fff",
        boxShadow:
          "0 20px 25px -5px rgba(0,0,0,0.1), 0 10px 10px -5px rgba(0,0,0,0.04)",
      }}
    >
      {/* SUMMARY */}
      <div style={{ display: "flex", gap: "10px", marginBottom: "16px" }}>
        <SummaryCard
          title="Total Collection"
          value={totalWithoutWallet}
          gradient="linear-gradient(135deg, #059669 0%, #34d399 100%)"
          icon={FaMoneyBillWave}
        />
        <SummaryCard
          title="Advance"
          value={advance}
          gradient="linear-gradient(135deg, #2563eb 0%, #60a5fa 100%)"
          icon={FaChartLine}
        />
        <SummaryCard
          title="Dues"
          value={actualDue}
          gradient="linear-gradient(135deg, #dc2626 0%, #f87171 100%)"
          icon={FaExclamationCircle}
        />
      </div>

      {/* PAYMENT MODES */}
      <SectionHeader title="Payment Modes" />

      {/* 🔥 FIXED AREA (NO HEIGHT / MINHEIGHT) */}
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        {nonWalletPayments.map((item, index) => (
          <Row
            key={index}
            label={item.paymentType}
            value={item.totalAmounts}
          />
        ))}

        {walletAmount > 0 && (
          <Row label="Wallet" value={walletAmount} />
        )}
      </Box>

      {/* TOTAL */}
      <div style={{ marginTop: "10px" }}>
        <Row label="Total Received" value={totalWithoutWallet} bold highlight />
      </div>

      {/* OTHER DETAILS */}
      <SectionHeader title="Other Details" />
      <Row label="GST Collected" value={taxAmount} />
      <Row label="Membership Sales" value={memberdata?.totalAmount || 0} />
      <Row label="Package Sales" value={packagedata?.totalAmount || 0} />
    </div>
  );
};

export default CashCollectionReport;



